import * as React from 'react';
import { Body2, Caption } from '@cian/ui-kit';

import { INewbuildingSummaryCell } from '../../../../types/newbuildingsCompare';
import { NewbuildingCallToAction } from '../../../../containers/NewbuildingCallToAction';
import { Link } from '../../../Link';
import * as style from './style.css';

export interface INewbuildingFloatingCardProps {
  cell: INewbuildingSummaryCell;
}

export const NewbuildingFloatingCard: React.FC<INewbuildingFloatingCardProps> = ({ cell }) => {
  const { data, state } = cell;

  if (!data) {
    return <Body2>{state.text ?? ''}</Body2>;
  }

  const { id, name, fullUrl, priceRange, builders, sellers } = data;

  return (
    <div className={style['container']}>
      <NewbuildingCallToAction onlyIcon builders={builders} newbuildingId={id} sellers={sellers} url={fullUrl} />
      <div className={style['info']}>
        <div className={style['name']}>
          <Link href={fullUrl} target="_blank">
            <Body2 color="text-main-default">{name}</Body2>
          </Link>
        </div>
        {priceRange && (
          <div className={style['price']}>
            <Caption>{priceRange}</Caption>
          </div>
        )}
      </div>
    </div>
  );
};
